import * as React from 'react';
import { connect } from 'react-redux';
import { FindAPDAppState } from '../classes/redux-states';
import { FindAPDApiModel } from '../redux/reducers/find-a-pd-api';
import { Dispatch } from 'redux';
import DentistListComponent from './dentist-list';
import { getSettings } from '../redux/actions/find-a-dentist-api';
import { PaginationComponent } from "../components/pagination/pagination";
import { setPage } from "../redux/actions/actions";
import { FindAPDPaginationModel } from "../redux/reducers/pagination-reducer";
import { FindAPDSettingsModel } from "../redux/reducers/find-a-pd-settings";
import FiltersContainer from './filters/filters-container';

interface StateToProps {
    noResults: boolean;
    currentPage: number;
    pagination: FindAPDPaginationModel;
    settings: FindAPDSettingsModel;
    totalPages: number;
    totalDentists: number;
}

interface DispatchToProps {
    getSettings: () => any;
    setPage: (currentPage: number) => any;
}

type FindAPDContainerProps = StateToProps & DispatchToProps;

export class FindAPDContainer extends React.Component<FindAPDContainerProps> {
    constructor(props: FindAPDContainerProps) {
        super(props);

		this.scrollToTop = this.scrollToTop.bind(this);
    }

	scrollToTop() {
		var featureWrapper = document.querySelector('[data-find-a-pd-results]');
		featureWrapper.scrollIntoView();

		// Adjust for sticky header
		var stickyHeaderEls = document.getElementsByClassName('header-nav');
		if (stickyHeaderEls.length > 0) {
			window.scrollBy(0, stickyHeaderEls[0].clientHeight * -1);
		}
	}

	onPageSelect(page: number) {
		 this.props.setPage(page);
		 this.scrollToTop();
	}

    componentWillMount() {
        this.props.getSettings();
    }

    render() {
        return (
            <div className="find-a-pd-container">
                <FiltersContainer />

				<DentistListComponent />
				<PaginationComponent totalDentists={this.props.totalDentists} totalPages={this.props.totalPages} pagination={this.props.pagination} settings={this.props.settings} setCurrentPage={page => this.onPageSelect(page)} />
            </div>
        )
    }
}

function mapStateToProps(state: FindAPDAppState): StateToProps {
    return {
        noResults: state.findAPDApiModel.noDentists,
        currentPage: state.findAPDPaginationModel.currentPage,
        pagination: state.findAPDPaginationModel,
        settings: state.findAPDSettingsModel,
        totalPages: state.findAPDApiModel.totalPages,
        totalDentists: state.findAPDApiModel.totalDentists
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
    return {
        getSettings: () => dispatch(getSettings()),
        setPage: (currentPage: number) => dispatch(setPage(currentPage))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FindAPDContainer)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/find-a-pd-container.tsx